import { BaseCrudStore } from '@monorepo/controlled/src/stores/base-crud.store';
import { FormError } from '@monorepo/tools/src/lib/models/form-error.model';
import { AccountsApi } from '../../apis/accounts.api';
import { HttpError } from '../../models/http-error.model';
import { AccountsModel, IAccount, ICreateAccount } from '../../models/account.model';

export class AccountsCrudStore extends BaseCrudStore<AccountsModel, ICreateAccount, IAccount, HttpError> {
	constructor() {
		super({
			apiLayer: AccountsApi,
			model: AccountsModel,
			errorModel: HttpError,
		});
	}

	public getCreateFormData(): Omit<IAccount, 'id'> {
		return this.getData();
	}

	public getEditFormData(): IAccount {
		return this.getData();
	}

	public isValid(): boolean {
		this.formStore.reset();
		const { name, use_internal_pricing, use_calc_payout } = this.getData();

		if (!name) {
			this.formStore.addError(new FormError('name', 'Please provide a name'));
		}

		if (use_calc_payout && !use_internal_pricing) {
			this.formStore.addError(new FormError('use_calc_payout', 'Use Calc Payout requires Use Internal Pricing'));
		}

		return this.formStore.getIsValid();
	}
}
